import { createRequest } from './createRequest'

export const notificationList = createRequest({ path: '/notification/list' })
export const notificationBroadcastPath = '/notification/broadcast'
export const notificationBroadcast = createRequest({ path: notificationBroadcastPath })
